import script from "./WorkflowAprovacaoPage.vue?vue&type=script&setup=true&lang=js"
export * from "./WorkflowAprovacaoPage.vue?vue&type=script&setup=true&lang=js"

import "./WorkflowAprovacaoPage.vue?vue&type=style&index=0&id=aa6edbaa&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-aa6edbaa"]])

export default __exports__